module.exports = __webpack_public_path__ + "static/media/import.337a07fa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/modules/rateLibrary/assets/import.svg
// module id = 7217
// module chunks = 0